import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authenticationService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (AuthenticationService.isPermitted(state.url)) {
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.authenticationService.logout('login',{queryParams: {returnUrl: state.url}});
        return false;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/_guards/auth.guard.ts